import parse from "html-react-parser"

export const useContent = query => {
  let tagObj
  const resolve = tag => {
    try {
      tagObj = tag.toLowerCase().replace(/_/g, ".")
      if (typeof tag !== "string") return undefined
    } catch {
      return undefined
    }
    try {
      if (
        query &&
        eval(`query.${tagObj}`) &&
        eval(`query.${tagObj}.content`) &&
        eval(`query.${tagObj}.content`).trim().length > 0
      )
        return parse(eval(`query.${tagObj}.content`))
    } catch {
      return tag.toUpperCase()
    }
    return tag.toUpperCase()
  }
  return { resolve }
}
